import React from "react";
import Image from "../../Tags/Image";

export default function BasicDetails({ company, withIcons = false }) {
  return (
    <div className={`${withIcons ? "text-sm" : "my-4 text-base"} w-full`}>
      <div className={`${withIcons ? "flex flex-col" : "flex items-center w-full flex-wrap"}`}>
        <span className="text-gray-600 leading-7 flex items-center">
          {withIcons && <Image src="/images/ext/briefcase.svg" className="mr-4 opacity-80 no-invert" width={20} />}
          {company?.industry ? company?.industry : "-"}
        </span>
        {company?.headquarters?.address && (
          <span className="flex items-center">
            {withIcons && (
              <Image src="/images/ext/companyinfo/location.svg" className="mr-4 opacity-70 no-invert" width={20} />
            )}
            {!withIcons && (
              <span className="inline-block h-[4px] w-[4px] bg-gray-500 rounded-full mx-3"></span>
            )}
            <span className="text-gray-600 leading-7">{company?.headquarters?.address}</span>
          </span>
        )}
        {(company?.employee_count?.exact || company?.employee_count?.range?.min) && (
          <span className="flex items-center">
            {withIcons && <Image src="/images/ext/user-outline.svg" className="mr-4 opacity-80 no-invert" width={20} />}
            {!withIcons && (
              <span className="inline-block h-[4px] w-[4px] bg-gray-500 rounded-full mx-3"></span>
            )}
            <span className="text-gray-600 leading-7">
              {company.headcount && company.headcount?.total ? (
                company.headcount?.total
              ) : (
                <>
                  {company?.employee_count?.exact ? (
                    company?.employee_count?.exact
                  ) : (
                    <>
                      {company?.employee_count?.range?.min}{" "}
                      {company?.employee_count?.range?.max && `- ${company?.employee_count?.range?.max}`}
                    </>
                  )}
                </>
              )}{" "}
              employees
            </span>
          </span>
        )}
        {company?.year_founded && (
          <span className="flex items-center">
            {withIcons && <Image src="/images/ext/clock.svg" className="mr-4 opacity-50 no-invert" width={20} />}
            {!withIcons && (
              <span className="inline-block h-[4px] w-[4px] bg-gray-500 rounded-full mx-3"></span>
            )}
            <span className="text-gray-600 leading-7">Founded in {company?.year_founded}</span>
          </span>
        )}
      </div>
    </div>
  );
}
